import React from 'react'
import classNames from 'classnames'
import ReactMarkdown, { type Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'

const REMARK_PLUGINS = [remarkGfm]

export interface MarkdownProps {
  children: string
  /** Applied alongside the base `simple-rich-text` prose class. */
  className?: string
  /** Prose font size, matching the `simple-rich-text` size modifiers. */
  size?: 'small' | 'large'
  /** Override how individual markdown elements render (e.g. links). */
  components?: Components
}

// A thin GFM markdown renderer wrapped in the shared `simple-rich-text` prose
// styling — tables, lists, code, blockquotes and headings all render like the
// rest of the product. Pass `components` to customise individual elements.
export function Markdown({
  children,
  className,
  size,
  components,
}: MarkdownProps) {
  return (
    <div className={classNames('simple-rich-text break-word', size, className)}>
      <ReactMarkdown remarkPlugins={REMARK_PLUGINS} components={components}>
        {children}
      </ReactMarkdown>
    </div>
  )
}
